import React from 'react';
import Logo from "assets/images/Logowhite.svg";
import { Link } from 'react-router-dom';
import { Input, Image } from 'antd';
import { RightOutlined, FacebookFilled, InstagramFilled, TwitterSquareFilled, MailOutlined } from '@ant-design/icons';
import { useAuthContext } from 'contexts/AuthContext';

import gapyIcon from "assets/icons/googlepay.svg";
import mastercardIcon from "assets/icons/mastercard.svg";
import paypalIcon from "assets/icons/paypal.svg";
import visaIcon from "assets/icons/visa.svg";
import callIcon from "assets/icons/call.svg";
import mailIcon from "assets/icons/mail.svg";
import mapIcon from "assets/icons/map.svg";

export default function Footer() {
    const { isAuthenticated } = useAuthContext()
    const date = new Date().getFullYear();

    return (
        <footer className='bg-primary text-white py-5'>
            <div className="container">
                <div className="row gy-4">
                    {/* Company Info */}
                    <div className="col-lg-3 col-md-6">
                        <Image src={Logo} alt="Krist Logo" preview={false} className="mb-3" />
                        <div className="d-flex align-items-center mb-2">
                            <Image src={callIcon} alt="Call" preview={false} className="me-3" height={20} />
                            <span>Phone: (704) 555-0127</span>
                        </div>
                        <div className="d-flex align-items-center mb-2">
                            <Image src={mailIcon} alt="Email" preview={false} className="me-3" height={20} />
                            <span>Email: krist@example.com</span>
                        </div>
                        <div className="d-flex align-items-start">
                            <Image src={mapIcon} alt="Address" preview={false} className="me-3" height={20} />
                            <span>Address: 3891 Ranchview California 62639 </span>
                        </div>
                    </div>

                    {/* Information Links */}
                    <div className="col-lg-3 col-md-6">
                        <h5 className="mb-3">Information</h5>
                        <ul className="list-unstyled">
                            {!isAuthenticated ?
                                <li className="mb-2"><Link className='text-white text-decoration-none' to="/login">Login</Link></li>
                                :
                                <>
                                    <li className="mb-2"><Link className='text-white text-decoration-none' to="/account">My Account</Link></li>
                                    <li className="mb-2"><Link className='text-white text-decoration-none' to="/cart">My Cart</Link></li>
                                    <li className="mb-2"><Link className='text-white text-decoration-none' to="/wishlist">My Wishlist</Link></li>
                                    <li className="mb-2"><Link className='text-white text-decoration-none' to="/checkout">Checkout</Link></li>
                                </>
                            }
                        </ul>
                    </div>

                    {/* Service Links */}
                    <div className="col-lg-3 col-md-6">
                        <h5 className="mb-3">Service</h5>
                        <ul className="list-unstyled">
                            <li className="mb-2"><Link className='text-white text-decoration-none' to="/about">About Us</Link></li>
                            <li className="mb-2"><Link className='text-white text-decoration-none' to="/careers">Careers</Link></li>
                            <li className="mb-2"><Link className='text-white text-decoration-none' to="/delivery">Delivery Information</Link></li>
                            <li className="mb-2"><Link className='text-white text-decoration-none' to="/privacy">Privacy Policy</Link></li>
                            <li className="mb-2"><Link className='text-white text-decoration-none' to="/terms">Terms & Conditions</Link></li>
                        </ul>
                    </div>

                    {/* Subscribe Section */}
                    <div className="col-lg-3 col-md-6">
                        <h5 className="mb-3">Subscribe</h5>
                        <p className="mb-4">Enter your email below to be the first to know about new collections and product launches.</p>
                        <Input placeholder="Your Email" className='custom-input bg-transparent text-white border-white' size='large' prefix={<MailOutlined style={{ color: 'rgba(255, 255, 255, 0.7)' }} />} suffix={<RightOutlined />} style={{ width: '100%' }} />
                    </div>
                </div>

                {/* Footer Bottom Section */}
                <div className="mt-4 pt-3 border-top">
                    <div className="d-flex flex-column flex-md-row justify-content-between align-items-center">
                        {/* Payment Icons */}
                        <div className="mb-3 mb-md-0">
                            <Image src={visaIcon} alt="Visa" preview={false} className="me-3" height={40} />
                            <Image src={mastercardIcon} alt="Mastercard" preview={false} className="me-3" height={40} />
                            <Image src={gapyIcon} alt="Google Pay" preview={false} className="me-3" height={40} />
                            <Image src={paypalIcon} alt="PayPal" preview={false} height={40} />
                        </div>

                        {/* Copyright Text */}
                        <div className="text-center mb-3 mb-md-0">
                            ©{date} Krist. All Rights Reserved.
                        </div>

                        {/* Social Icons */}
                        <div>
                            <Link to="#" className="text-white me-3"><FacebookFilled className='fs-4' /></Link>
                            <Link to="#" className="text-white me-3"><InstagramFilled className='fs-4' /></Link>
                            <Link to="#" className="text-white"><TwitterSquareFilled className='fs-4' /></Link>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    );
}
